import React from 'react';
import Drawer from '../../../../customer/components/ui/drawer';
import { is1024andSmaller } from '../../../utils/ui.utils';
import classes from './specs-popup.scss';
export function SpecsPopupComponent({
  specs,
  images,
  onClose,
  onImageClick,
  open,
  isLimitedEdition,
  description
}) {
  return /*#__PURE__*/React.createElement(Drawer, {
    prerenderForCrawlers: true,
    dataDrawer: "Specifications",
    onClose: onClose,
    headerTitle: is1024andSmaller() ? 'Description and Specifications' : 'Specifications',
    headerClassName: classes.header,
    open: open,
    closeClassName: isLimitedEdition ? classes.orange : classes.close
  }, /*#__PURE__*/React.createElement("div", null, !!description && /*#__PURE__*/React.createElement("div", {
    className: classes.descriptionContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paraHeader
  }, "Description"), /*#__PURE__*/React.createElement("div", {
    className: classes.description
  }, description)), !!specs && /*#__PURE__*/React.createElement("div", {
    className: classes.materials
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paraHeader
  }, "Materials"), /*#__PURE__*/React.createElement("div", {
    className: classes.specs,
    dangerouslySetInnerHTML: {
      __html: specs
    }
  })), !!images && !!images.length && /*#__PURE__*/React.createElement("div", {
    className: classes.imagesContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paraHeader
  }, "Images"), /*#__PURE__*/React.createElement("div", {
    className: classes.images
  }, images.map((image, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: classes.imageContainer,
    onClick: () => onImageClick ? onImageClick(index) : undefined
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.image,
    src: image.url,
    alt: image.alt
  })))))));
}